import React from 'react'
import PropTypes from 'prop-types'
import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

const DepartmentAutocomplete = ({
  multiple,
  value,
  onChange,
  onBlur,
  options,
  disabled,
  error,
  helperText,
}) => (
  <Autocomplete
    multiple={multiple}
    value={multiple ? value || [] : value?.[0] ?? null}
    onChange={onChange}
    onBlur={onBlur}
    options={options}
    getOptionLabel={(option) => option?.name || ''}
    getOptionSelected={(option, selected) => option?.id === selected?.id}
    disabled={disabled}
    renderInput={(params) => (
      <TextField
        {...params}
        variant="outlined"
        size="small"
        placeholder="Selecione um departamento"
        error={error}
        helperText={helperText}
      />
    )}
  />
)

DepartmentAutocomplete.propTypes = {
  multiple: PropTypes.bool,
  value: PropTypes.array,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  options: PropTypes.array,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
}

export default DepartmentAutocomplete
